<template>
  <ar-simple-select
    class="select"
    enable-filter
    :items="decoratedPromoters"
    :default-select-index="selectedPromoterIndex"
    placeholder="Please select or search for an account"
    @select="handlePromoterSelect"
    @filterStringInput="handleFilterStringInput"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { debounce } from "debounce";

export default {
  name: 'PromoterSelect',
  props: {
    value: { // Value equals to promoter-oid
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedPromoterOid: null,
    };
  },
  computed: {
    ...mapState({
      promoters: state => state.admin.promoters,
    }),
    selectedPromoterIndex() {
      return this.promoters.findIndex(promoter => promoter.oid === this.selectedPromoterOid);
    },
    decoratedPromoters() {
      return this.promoters.map(promoter => ({
        name: `${promoter.name} - ${promoter.emailAddress  } (${promoter.oid})`,
        oid: promoter.oid,
      }));
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.selectedPromoterOid = val;
      },
      immediate: true,
    },
  },
  created() {
    this.fetchPromotersDebouncing = debounce(this.fetchPromoters, 300);
    this.fetchPromotersDebouncing('');
  },
  methods: {
    ...mapActions([
      'admin/FETCH_MORE_PROMOTERS',
    ]),
    fetchPromoters(filterString) {
      this['admin/FETCH_MORE_PROMOTERS']({
        filterString,
        reload: true
      });
    },
    getPromoter(oid) {
      return this.promoters.find(promoter => promoter.oid === oid);
    },

    handlePromoterSelect(promoter) {
      this.$emit('select', this.getPromoter(promoter.oid));
      this.$emit('input', promoter.oid);
    },

    handleFilterStringInput(filterString) {
      this.fetchPromotersDebouncing(filterString);
    },
  },
};
</script>
